export default "__VITE_ASSET__DuRDgNLX__"